import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import {
  IGetHistoricoVeiculoListParams,
  IGetHistoricoVeiculoListResponse,
  IGetHistoricoVeiculoItem
} from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';

@Component({
  selector: 'app-historico-veiculo',
  templateUrl: './historico-veiculo.component.html',
  styleUrls: ['./historico-veiculo.component.scss']
})
export class HistoricoVeiculoComponent {
  form = this.fb.group({
    TX_PLCA: [null as string | null, Validators.required],
    DT_INIC: [null as string | null],
    DT_FIM: [null as string | null]
  });

  isLoading: boolean = false;
  numeroPagina: number = 0;
  maxPages: number = 1;
  tableData: Array<any> = [];

  pesquisaParams = {
    PAGE_NUMBER: 1,
    PAGE_SIZE: 20
  };

  tableColumns = [
    { header: 'Data/Hora', key: 'dataEvento', type: 'text' },
    { header: 'Tipo', key: 'tipo', type: 'text' },
    { header: 'Placa', key: 'placa', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    { header: 'Serviço', key: 'servico', type: 'text' },
    { header: 'Status', key: 'status', type: 'text' },
    { header: 'Operador', key: 'operador', type: 'text' }
  ];

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64
  ) {}

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      if (this.form.controls.TX_PLCA.valid) {
        this.pesquisaParams.PAGE_NUMBER = 1;
        this.numeroPagina = 0;
        this.loadData();
      } else {
        this.tableData = [];
        this.maxPages = 1;
      }
    });
  }

  mudarPagina(pagina: number): void {
    this.pesquisaParams.PAGE_NUMBER = pagina + 1;
    this.numeroPagina = pagina;
    this.loadData();
  }

  private createPayload(): IGetHistoricoVeiculoListParams {
    return {
      TX_PLCA: this.form.controls.TX_PLCA.value ?? undefined,
      DT_INIC: this.form.controls.DT_INIC.value ?? undefined,
      DT_FIM: this.form.controls.DT_FIM.value ?? undefined,
      PAGE_NUMBER: this.pesquisaParams.PAGE_NUMBER,
      PAGE_SIZE: this.pesquisaParams.PAGE_SIZE
    };
  }

  loadData(): void {
    if (!this.form.controls.TX_PLCA.value) return;

    this.isLoading = true;
    const payload = this.createPayload();

    this.reportService.GetHistoricoVeiculo(payload).subscribe({
      next: (response: IGetHistoricoVeiculoListResponse) => {
        this.tableData = response.ITEMS.map((item: IGetHistoricoVeiculoItem) => ({
          dataEvento: formatarData(item.DT_EVENTO) ?? '---',
          tipo: item.TX_TIPO ?? '---',
          placa: formatarPlaca(item.TX_PLCA) ?? '---',
          motorista: item.NM_MOTORISTA ?? '---',
          servico: item.TX_SERVICO ?? '---',
          status: item.TX_STATUS ?? '---',
          operador: item.NM_OPERADOR ?? '---'
        }));
        this.maxPages = response.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarExcel(): void {
    if (!this.form.controls.TX_PLCA.value) return;

    this.isLoading = true;
    const payload = this.createPayload();
    this.reportService.GetReportHistoricoVeiculoExcel({
      TX_PLCA: payload.TX_PLCA,
      DT_INIC: payload.DT_INIC,
      DT_FIM: payload.DT_FIM
    }).subscribe({
      next: response => {
        this.appExportBase64.downloadExcel(response.ReportBase64, 'Histórico Veículo.xlsx');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarPDF(): void {
    if (!this.form.controls.TX_PLCA.value) return;

    this.isLoading = true;
    const payload = this.createPayload();
    this.reportService.GetReportHistoricoVeiculoPdf({
      TX_PLCA: payload.TX_PLCA,
      DT_INIC: payload.DT_INIC,
      DT_FIM: payload.DT_FIM
    }).subscribe({
      next: response => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'Histórico Veículo.pdf');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
